
















































































































































































import Vue from 'vue'
import { Component, Mixin, Lifecycle, Prop, p, Watch } from 'av-ts'
import { EventBus } from '@/eventbus'
import { VueUtils } from '@/mixins'
import { StoreType } from '@/store'
import { ILesson, languages, ITranslation, IWord, IAnswer, ITestConfig, ITestResult } from '@/models'

@Component({
  store: ['user']
})
export default class LessonTest extends Mixin(EventBus, VueUtils) {
  $store!: StoreType
  // lesson is passed by parent route
  @Prop lesson = p(Object) as ILesson

  saveResults = true
  testConfig: ITestConfig = {
    nbWords: 10,
    lang: '', // empty string means mixed language test
    flowMode: 'UserControlled' as 'UserControlled' | 'Timed' | 'NoPause', // 0 = user controlled, 1 = timed, 2 = no pause
    pauseAfterAnswerSeconds: 2,
    pauseAfterAnswer: 2000, // timeout, -1 = no automatic progression, 0 = wait for user action
    words: undefined // only populated when replaying a test
  }

  replayTest = null as ITestResult | null
  replayConfig = {
    wordsSelection: 'All' as 'All' | 'ErrorsOnly'
  }

  testSession = {
    startTime: '',
    finishTime: '',
    testWords: [] as IWord[],
    answers: [] as IAnswer[],
    langMap: {} as {[key: string]: string},
    curIdx: -1,
    hasAnswer: false,
    answerTxt: '',
    correctAnswers: 0,
    wrongAnswers: 0,
    attempts: 0,
    isFinished(): boolean { return this.curIdx+1 >= this.testWords.length },
    nextQuestion(): boolean {
      if (this.curIdx+1 < this.testWords.length) {
        this.curIdx++ // next question
        this.hasAnswer = false
        return true
      } else
        return false
    }
  }

  quizState = 'not_started' as 'not_started' | 'started' | 'results'

  answerOutcome = undefined as undefined | any

  test(str: any) {
    console.debug('*** TEST STR = ***', str)
  }

  @Lifecycle
  async created() {
    console.debug('[LessonTest.vue] created')
    console.debug('route params =', this.$route.params)
    // replay test ?
    const testResultId: string | undefined = this.$route.params.testResultId
    if (testResultId) {
      const testResult = await this.$store.getTestResult(testResultId)
      if (testResult) {
        Object.assign(this.testConfig, testResult.config)
        this.replayTest = testResult
        this.testSession.attempts = testResult.attempts
        this.testConfig.words = testResult.questions
      }
    }
  }

  @Lifecycle
  mounted() {
    this.testConfig.lang = this.lesson.srcLang
    if (this.lesson.words.length < this.testConfig.nbWords)
      this.testConfig.nbWords = this.lesson.words.length
  }

  get totalProgress(): number {
    //if (this.testSession.curIdx == -1) return 0
    return (this.testSession.curIdx + 1) / this.testSession.testWords.length * 100
  }

  get totalCorrectProgress(): number {
    if (this.testSession.curIdx == -1) return 0
    return this.testSession.correctAnswers / this.testSession.testWords.length * 100
  }

  get totalWrongProgress(): number {
    if (this.testSession.curIdx == -1) return 0
    return this.testSession.wrongAnswers / this.testSession.testWords.length * 100
  }

  get score(): string | undefined {
    if (this.testSession.curIdx == -1) return undefined
    return `${Math.round(this.totalCorrectProgress)} %`
  }

  get passTest(): boolean {
    return this.totalCorrectProgress >= 70
  }

  get pauseAfterAnswer(): boolean {
    return this.testConfig.pauseAfterAnswer == -1
  }

  startTest() {
    this.testSession.startTime = new Date().toJSON()

    if (this.testConfig.flowMode == 'UserControlled')
      this.testConfig.pauseAfterAnswer = -1
    else if (this.testConfig.flowMode == 'Timed')
      this.testConfig.pauseAfterAnswer = this.testConfig.pauseAfterAnswerSeconds * 1000
    else if (this.testConfig.flowMode == 'NoPause')
      this.testConfig.pauseAfterAnswer = 0

    // words selection
    if (this.replayTest && this.replayConfig.wordsSelection == 'ErrorsOnly') {
      // get error words only
      this.testSession.testWords = []
      this.replayTest.answers.forEach((answer, index) => {
        if (answer.correct === false)
          this.testSession.testWords.push(this.replayTest!.questions[index])
      })
      if (this.testSession.testWords.length != this.replayTest.wrongAnswers)
        throw new Error('Warning: errors question count is not the same as wrong answers !')
    } else {
      if (this.testConfig.words) {
        // words selected in config
        this.testSession.testWords = this.testConfig.words
      } else {
        // if no words are pre-selected, select randow words
        const randomTsls = shuffleArray(this.lesson.words)
        //console.debug('randomTsls = ', randomTsls)
        const testTsls = randomTsls.slice(0, this.testConfig.nbWords)

        this.testSession.testWords = testTsls.map(tsl => {
          if (this.testConfig.lang === this.lesson.srcLang) {
            return { word: tsl.srcWord, lang: this.lesson.srcLang }
          } else if (this.testConfig.lang === this.lesson.tgtLang) {
            return { word: tsl.tgtWord, lang: this.lesson.tgtLang }
          } else { // mixed
            if (Math.random() < 0.5)
              return { word: tsl.srcWord, lang: this.lesson.srcLang }
            else
              return { word: tsl.tgtWord, lang: this.lesson.tgtLang }
          }
        })
      }
    }

    const langMap: {[key: string]: string} = {}
    langMap[this.lesson.srcLang] = this.lesson.tgtLang
    langMap[this.lesson.tgtLang] = this.lesson.srcLang
    this.testSession.langMap = langMap
    this.restartTest()
    console.debug('this.testSession =', this.testSession)
  }

  restartTest() {
    this.testSession.curIdx = 0
    this.testSession.answerTxt = ''
    this.testSession.answers = []
    this.testSession.hasAnswer = false
    this.testSession.correctAnswers = 0
    this.testSession.wrongAnswers = 0
    this.testSession.attempts++
    this.replayTest = null
    this.quizState = 'started'
    this.$nextTick(() => this.setFocus(this.$refs.answerTxtField))
  }

  newTest() {
    // reset words selection
    this.testConfig.words = undefined
    this.quizState = 'not_started'
  }

  clearAnswer() {
    this.testSession.answerTxt = ''
  }
  dontKnow() {
    this.testSession.answerTxt = ''
    this.acceptAnswer()
  }
  acceptAnswer() {
    const sess = this.testSession
    sess.hasAnswer = true

    const correctAnswers = this.getCorrectAnswersForWord(sess.testWords[sess.curIdx])
    const isCorrect = correctAnswers.find(_ => _.word === sess.answerTxt) != null
    
    const answer: IAnswer = {
      value: sess.answerTxt,
      correct: isCorrect
    }
    this.testSession.answers.push(answer) // XXX: assuming we are asking question in order, might want to associate it directly to question
    if (isCorrect) {
      sess.correctAnswers++
    } else { 
      sess.wrongAnswers++
    }
    console.debug('answer=', answer)

    if (this.pauseAfterAnswer) {
      // no automatic progression, wait for user to proceed to next question
      this.answerOutcome = { isCorrect, correctAnswers }
      // this.$nextTick(() => this.setFocus((this.$refs.nextWordBtn as any).$el))
      this.$nextTick(() => {
        const btn = this.$refs.nextWordBtn as any
        console.debug('btn=', btn)
        this.setFocus(btn.$el)
      })
    } else {
      if (this.testConfig.pauseAfterAnswer == 0) {
        // immediately proceed to next question
        this.proceedToNextQuestion()
      } else  {
        this.answerOutcome = { isCorrect, correctAnswers }
        this.answerOutcome.timeout = setTimeout(this.proceedToNextQuestion, this.testConfig.pauseAfterAnswer)
      }
    }
  }
  nextWord() {
    console.debug('*** nextWord ***')
    this.proceedToNextQuestion()
    return false
  }


  proceedToNextQuestion() {
    if (this.answerOutcome && this.answerOutcome.timeout)
      clearTimeout(this.answerOutcome.timeout)
    this.answerOutcome = undefined
    if (this.testSession.nextQuestion()) {
      this.clearAnswer()
      this.setFocus(this.$refs.answerTxtField)
    } else {
      this.finishTest('finished')
    }
  }

  private finishTest(state: 'finished' | 'cancelled') {
    this.testSession.finishTime = new Date().toJSON()
    // show results
    if (this.testConfig.flowMode == 'Timed') {
      // leave some time to show last answer result
      setTimeout(() => this.quizState = 'results', 2000)
    }
    else
      this.quizState = 'results'
    // save results
    const toRemove = 'words'
    const { [toRemove]: _1, ...lessonMD } = this.lesson // remove words from lesson (because it is in property "questions")
    const { [toRemove]: _2, ...testConfig } = this.testConfig // remove words from config (because it is in property "questions")
    const testResult: ITestResult = {
      _id: new Date().toJSON(),
      user: this.$store.user!,
      lesson: lessonMD,
      config: testConfig,
      startTime: this.testSession.startTime,
      finishTime: this.testSession.finishTime,
      attempts: this.testSession.attempts,
      questions: this.testSession.testWords,
      answers: this.testSession.answers,
      state: state,
      questionCount: this.testSession.testWords.length,
      correctAnswers: this.testSession.correctAnswers,
      wrongAnswers: this.testSession.wrongAnswers,
      score: Math.round(this.totalCorrectProgress),
      pass: this.passTest
    }
    console.debug('testResult', testResult)
    if (this.saveResults) {
      this.$store.saveTestResult(testResult)
    }
  }

  private getCorrectAnswersForWord(word: IWord): IWord[] {
    const rslt = [] as IWord[]
    if (word.lang == this.lesson.srcLang)
      this.lesson.words.forEach(itl => {
        if (itl.srcWord === word.word)
          rslt.push({word: itl.tgtWord, lang: this.lesson.tgtLang})
      })
    else
      this.lesson.words.forEach(itl => {
        if (itl.tgtWord === word.word)
          rslt.push({word: itl.srcWord, lang: this.lesson.srcLang})
      })
    return rslt
  }
}

// @see https://www.kirupa.com/html5/shuffling_array_js.htm
function shuffleArray<T>(array: T[]): T[] {
  const rslt = [... array]
  for (let i = rslt.length - 1; i > 0; i--) {
    const randomIndex = Math.floor(Math.random() * (i + 1))
    const item = rslt[randomIndex]
    rslt[randomIndex] = rslt[i]
    rslt[i] = item
  }
  return rslt
}

